import React, { useState, useEffect } from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import { useForm, FormProvider } from 'react-hook-form';
import { Button, message, Steps} from 'antd';
import PageHeader from "../../layouts/PageHeader";
import {iconMapping} from "../../configs/AppsConfig";
import {generateFormStages, getDefaultValues} from "./stageConfig";
import QuestionContainer from "./components/QuestionContainer";
import {fetchDetailedPortfolioObjects} from "../../api/portfolioApi";
import {selectFullPortfolios} from "../../store/slices/portfolios.slice";
import {useSelectorWithArgs} from "../../utils/selectors";
import {applyRules} from "./rules";
import { setNewPortfolioBuilderContext } from "../../store/slices/builder.slice";

const { Step } = Steps;



const FormBuilder = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const portfolioIds = useSelector(state=>state.appStates.portfolioPathIds)
    const [currentStep, setCurrentStep] = useState(0);
    const methods = useForm({
      defaultValues: getDefaultValues(),
      context: { currentStep, setCurrentStep } // Include currentStep in form context
    });
    const { handleSubmit, getValues } = methods;

    const steps = generateFormStages({ control: methods.control });

    useEffect(() => {
        if (portfolioIds.length === 0){
            message.warning('No portfolios selected. Please select portfolios to build a form.')
            return
        }
        dispatch(fetchDetailedPortfolioObjects(portfolioIds));
    }, [dispatch]);

    const portfolios = useSelectorWithArgs(selectFullPortfolios, portfolioIds);
    const onSubmit = data => {

        const filteredPortfolios = applyRules(portfolios, data);
        dispatch(setNewPortfolioBuilderContext({items: filteredPortfolios, name: "Question Based Portfolio"}))
        message.success('Portfolio form submitted successfully!');
        navigate('/builders/portfolio')
    };

    const actions = [
        <Button size={'large'} type={'primary'} htmlType={'submit'} onClick={()=>handleSubmit(onSubmit)}>PREVIEW</Button>
    ]

    return (
        <div style={{height:'100vh'}}>
            <FormProvider {...methods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <PageHeader
                        title="Form Builder"
                        logoUrl={iconMapping.formBuilder}
                        actions={actions}
                    />
                    <Steps current={currentStep}
                           style={{
                               padding: '2.5% 5%',
                               maxWidth: '1400px',
                               margin: 'auto'
                           }}
                           percent={currentStep / steps.length * 100 || 0}>
                        {steps.map(step => (
                          <Step
                              progressDot={(dot)=>dot}
                              onClick={()=>setCurrentStep(steps.indexOf(step))}
                              key={step.name}
                              title={step.name}
                              style={{fontWeight: '600', fontFamily: "var(--font-title)"}}
                              description={step?.description}
                          />
                        ))}
                    </Steps>
                    <div style={{maxWidth: '80%', margin: 'auto'}}>
                        <QuestionContainer steps={steps} currentStep={currentStep} setCurrentStep={setCurrentStep} />
                    </div>
                </form>

            </FormProvider>
        </div>
    );
};

export default FormBuilder;
